import { Board, User } from 'types';

type GetFirstPartnerAndRepresentantProps = {
  board: Board;
  user: User;
};

type GetFirstPartnerAndRepresentantResult = {
  firstPartnerId: string | null;
  firstPartnerRepresentantId: string | null;
};

export const getFirstPartnerAndRepresentant = ({
  board,
  user,
}: GetFirstPartnerAndRepresentantProps): GetFirstPartnerAndRepresentantResult => {
  const boardParticipantsIds =
    board?.participants?.map((participant) => participant.member) || [];

  const userPartnersIds = user?.partners || [];
  const userPartnerRepresentantsIds = user?.partnerRepresentants || [];

  const firstPartnerId = userPartnersIds.length
    ? boardParticipantsIds.find((participantId) =>
        userPartnersIds.includes(participantId)
      ) || null
    : null;
  const firstPartnerRepresentantId = userPartnerRepresentantsIds.length
    ? boardParticipantsIds.find((participantId) =>
        userPartnerRepresentantsIds.includes(participantId)
      ) || null
    : null;

  return {
    firstPartnerId,
    firstPartnerRepresentantId,
  };
};
